import { render, staticRenderFns } from "./PressRelease-2022-09-24.vue?vue&type=template&id=62656b5f&scoped=true"
import script from "./PressRelease-2022-09-24.vue?vue&type=script&lang=js"
export * from "./PressRelease-2022-09-24.vue?vue&type=script&lang=js"
import style0 from "./PressRelease-2022-09-24.vue?vue&type=style&index=0&id=62656b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62656b5f",
  null
  
)

export default component.exports